export default {"src":"/_next/static/media/Basket-Header-Black.974b3723.svg","height":19,"width":27};